module.exports = __webpack_public_path__ + "img/robot.fc64613a.png";